import { FormGroup, FormGroupProps } from '@mui/material'
import { FC } from 'react'

const FormGroupWrapper: FC<FormGroupProps> = ({ ...props }) => (
  <FormGroup {...props} />
)

export default FormGroupWrapper
